import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const NewOrgModal = ({show, toggle}) => {
  const [, dispatch] = useStateValue()

  const addNewOrg = async () => {
    try {
      const resp = await client.post(endpoints.addNewOrg(), { internalOrgName: newOrgName })
      toast.success("Successfully added new organization.")
      dispatch({ type: 'updateTable', tableData: resp.data.organizations })
    } catch (err) {
      console.log(err)
      toast.error("There was an error trying to create a new organization.")
    } finally {
      toggle(!show)
    }
  }

  const [newOrgName, updateNewOrgName] = useState('')

  const handleOrgNameChange = e => {
    updateNewOrgName(e.target.value)
  }

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Organization</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="orgName">
          <Form.Label>New Organization Name</Form.Label>
          <Form.Control
            type="text"
            onChange={handleOrgNameChange}
            value={newOrgName}
          />
        </Form.Group>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => addNewOrg()}
        >
          <div className="fa-regular fa-plus fa-fw mr-2" /> Add Organization
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewOrgModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default NewOrgModal
